module.exports = __webpack_public_path__ + "bn.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/1x1/bn.svg
// module id = 713
// module chunks = 0